import type {
  PatchAdminV1OrgStoresIdBody,
  PatchAdminV1StoresStoreIdTaxRatesIdBody,
  PostAdminV1StoresStoreIdTaxRatesBody,
  Store,
  TaxRate,
} from '@nucleus-commerce/api-client/admin';

import type {
  TaxRateFormInput,
  TaxRateFormOutput,
  TaxSettingsForm,
} from '../schemas/tax-rate-form-schema';
import { fractionToPercent, percentToFraction } from '../schemas/tax-rate-rules';

const orNull = (value: string) => (value === '' ? null : value);

export function emptyTaxRateForm(countryCode: string, priority: number): TaxRateFormInput {
  return {
    name: '',
    countryCode,
    region: '',
    postalPattern: '',
    ratePercent: '',
    appliesToShipping: false,
    priority,
    isActive: true,
  };
}

export function fromTaxRate(rate: TaxRate): TaxRateFormInput {
  return {
    name: rate.name,
    countryCode: rate.countryCode,
    region: rate.region ?? '',
    postalPattern: rate.postalPattern ?? '',
    ratePercent: String(fractionToPercent(rate.rate)),
    appliesToShipping: rate.appliesToShipping,
    priority: rate.priority,
    isActive: rate.isActive,
  };
}

/** Create and update take the same full shape; blank region and pattern mean "everywhere". */
export function toTaxRateBody(
  values: TaxRateFormOutput,
): PostAdminV1StoresStoreIdTaxRatesBody & PatchAdminV1StoresStoreIdTaxRatesIdBody {
  return {
    name: values.name,
    countryCode: values.countryCode,
    region: orNull(values.region.toUpperCase()),
    postalPattern: orNull(values.postalPattern),
    rate: percentToFraction(values.ratePercent),
    appliesToShipping: values.appliesToShipping,
    priority: values.priority,
    isActive: values.isActive,
  };
}

export function fromTaxSettings(store: Store): TaxSettingsForm {
  return {
    provider: store.settings.tax.provider,
    pricesIncludeTax: store.settings.tax.pricesIncludeTax,
  };
}

export function toTaxSettingsPatch(values: TaxSettingsForm): PatchAdminV1OrgStoresIdBody {
  return { settings: { tax: values } };
}
